import React, { useEffect, useState } from "react";
import { api } from "@/api/client.js";
import { DataTable } from "@/components/DataTable.jsx";
import { PUBLIC_RESOURCES } from "@/content/expedition.js";
import { useOrignalUi } from "@/hooks/useOrignalUi.js";

export function DocumentsPage() {
  const { ui, lang } = useOrignalUi();
  const [items, setItems] = useState([]);
  useEffect(() => {
    api("/api/documents").then((d) => {
      const seen = new Set();
      const unique = [];
      for (const row of d.items || []) {
        const key = row.original_filename || row.title;
        if (seen.has(key)) continue;
        seen.add(key);
        if (/avenza/i.test(`${row.title || ""} ${row.notes || ""} ${row.url || ""} ${row.source_name || ""}`)) continue;
        unique.push(row);
      }
      setItems(unique);
    }).catch(() => {});
  }, []);
  return (
    <main className="og-page" data-testid="page-documents">
      <h1>{ui.documents.title}</h1>
      <p className="og-lead">{ui.documents.subtitle}</p>
      <section className="og-card" data-testid="docs-sepaq">
        <p className="og-kicker">Sépaq</p>
        <h3>{ui.documents.folder}</h3>
        <article className="og-food-card">
          <strong>{ui.documents.aideMemoire}</strong>
          <p className="og-hint">Sépaq · chalet-aide-memoire.pdf · 2026-08-26</p>
          <a className="og-btn og-btn--primary" href="/docs/chalet-aide-memoire.pdf" target="_blank" rel="noreferrer" data-testid="aide-memoire">{ui.documents.open}</a>
        </article>
      </section>
      <section className="og-card" data-testid="docs-maps">
        <p className="og-kicker">{ui.documents.officialMaps}</p>
        <article className="og-food-card">
          <strong>{ui.documents.officialMap}</strong>
          <div className="og-preview-map" style={{ backgroundImage: "url(/media/secteur4-preview.png)" }} />
          <a className="og-btn og-btn--primary" href="/docs/secteur4.pdf" target="_blank" rel="noreferrer" data-testid="secteur4-pdf">{ui.documents.open}</a>
        </article>
        <article className="og-food-card">
          <strong>{ui.documents.kmz}</strong>
          <a className="og-btn" href="/docs/POR_Secteur_Chasse_Orignal.kmz" data-testid="secteur4-kmz">{ui.app.download}</a>
        </article>
      </section>
      <section className="og-card" data-testid="docs-reservation">
        <p className="og-kicker">{ui.documents.reservation}</p>
        <article className="og-food-card">
          <strong>{ui.documents.reservation} 39632719</strong>
          <p className="og-hint">Luc Young · Chalet Desrochers · privé</p>
          <a className="og-btn" href="/docs/Confirmation-39632719-111037.pdf" target="_blank" rel="noreferrer" data-testid="reservation-pdf">{ui.documents.open}</a>
        </article>
      </section>
      <section className="og-card" data-testid="docs-folder">
        <p className="og-kicker">{ui.documents.folder}</p>
        <h3>{ui.trip.resources}</h3>
        {PUBLIC_RESOURCES.filter((r) => r.id !== "avenza").map((r) => (
          <article key={r.id || r.url} className="og-food-card">
            <span>{r.icon} </span>
            <strong>{r.title}</strong>
            <p className="og-hint">{r.source} · {r.consulted}</p>
            <p>{lang === "en" ? r.noteEn : r.note}</p>
            <a className="og-btn" href={r.url} target="_blank" rel="noreferrer">{ui.documents.open}</a>
          </article>
        ))}
      </section>
      <DataTable
        rows={items}
        searchKeys={["title", "category", "notes"]}
        columns={[
          { key: "title", label: ui.documents.title },
          { key: "category", label: ui.expenses.category },
        ]}
        emptyLabel={ui.documents.empty}
        testId="documents-table"
      />
    </main>
  );
}
